import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_OPERATORS_LIST = createRequestTypes('GET_OPERATORS_LIST');
export const GET_VEHICLES_LIST = createRequestTypes('GET_VEHICLES_LIST');
export const GET_OPERATOR_BY_ID = createRequestTypes('GET_OPERATOR_BY_ID');
export const UPDATE_BASIC_DETAILS = createRequestTypes('UPDATE_BASIC_DETAILS');
export const UPDATE_COMPLIANCES = createRequestTypes('UPDATE_COMPLIANCES');
export const UPDATE_COMPANY_DETAILS = createRequestTypes('UPDATE_COMPANY_DETAILS');
export const CREATE_OPERATOR = createRequestTypes('CREATE_OPERATOR');
export const CREATE_BANK_ACCOUNT = createRequestTypes('CREATE_BANK_ACCOUNT');
export const RESET_VEHICLES = createRequestTypes('RESET_VEHICLES');
export const GET_TRIPS = createRequestTypes('GET_TRIPS');
export const SET_ACTIVE_VEHICLE = createRequestTypes('SET_ACTIVE_VEHICLE');
export const SETTLE_TRIP = createRequestTypes('SETTLE_TRIP');
export const VIEW_RC = createRequestTypes('VIEW_RC');
export const RESET_RC_VIEW = createRequestTypes('RESET_RC_VIEW');
export const EDIT_BANK_ACCOUNT = createRequestTypes('EDIT_BANK_ACCOUNT');
export const VERIFY_BANK_ACCOUNT_OTP = createRequestTypes('VERIFY_BANK_ACCOUNT_OTP');
export const RESEND_BANK_ACCOUNT_OTP = createRequestTypes('RESEND_BANK_ACCOUNT_OTP');
export const CLEAR_BANK_ACCOUNT_OTP = 'CLEAR_BANK_ACCOUNT_OTP';
export const clearBankAccountOtp = () => createAction(CLEAR_BANK_ACCOUNT_OTP);
export const DISABLE_ACCOUNT = createRequestTypes('DISABLE_ACCOUNT');
export const SEND_TO_THIRD_PARTY = createRequestTypes('SEND_TO_THIRD_PARTY');
export const DOWNLOAD_LEDGER = createRequestTypes('DOWNLOAD_LEDGER');
export const GET_FILE_UPLOAD = createRequestTypes('GET_FILE_UPLOAD');
export const GET_TDS_FILE_UPLOAD = createRequestTypes('GET_TDS_FILE_UPLOAD');
export const UPDATE_DOCUMENTS = createRequestTypes('UPDATE_DOCUMENTS');
export const GET_FILE_VIEW = createRequestTypes('GET_FILE_VIEW');
export const RESET_FILE_URL = createRequestTypes('RESET_FILE_URL');
export const RESET_TDS_ERROR_MSG = createRequestTypes('RESET_TDS_ERROR_MSG');
export const RESET_TDS_FILE_URL = createRequestTypes('RESET_TDS_FILE_URL');
export const GET_RC_LINK = createRequestTypes('GET_RC_LINK');
export const RESET_EDIT_STATUS = createRequestTypes('RESET_EDIT_STATUS');
export const GET_BANK_ACCOUNT = createRequestTypes('GET_BANK_ACCOUNT');
export const CREATE_OPERATOR_VEHICLE = createRequestTypes('CREATE_OPERATOR_VEHICLE');
export const RESET_UPLOAD_STATUS = createRequestTypes('RESET_UPLOAD_STATUS');
export const GET_OPERATOR_SEARCH = createRequestTypes('GET_OPERATOR_SEARCH');
export const RESET_SETTLED_STATUS = createRequestTypes('RESET_SETTLED_STATUS');
export const RESET_UNSETTLED = createRequestTypes('RESET_UNSETTLED');
export const RESET_SETTLED = createRequestTypes('RESET_SETTLED');
export const GET_OPERATOR_TYPE = createRequestTypes('GET_OPERATOR_TYPE');
export const SAVE_RC_LINK = createRequestTypes('SAVE_RC_LINK');
export const GET_OPERATOR_STATUS = createRequestTypes('GET_OPERATOR_STATUS');
export const GET_PHONE_NO = createRequestTypes('GET_PHONE_NO');
export const GET_TRIP_COUNT = createRequestTypes('GET_TRIP_COUNT');
export const RESET_OPERATOR_LIST = createRequestTypes('RESET_OPERATOR_LIST');
export const ADD_TDS_DEC = createRequestTypes('ADD_TDS_DEC');
export const EDIT_TDS_DEC = createRequestTypes('EDIT_TDS_DEC');
export const RESET_ACTIVE_VEHICLE = createRequestTypes('RESET_ACTIVE_VEHICLE');
export const GET_TDS_VIEW_URL = createRequestTypes('GET_TDS_VIEW_URL');
export const UNCHECK_FLAGS = createRequestTypes('UNCHECK_FLAGS');
export const GET_LANES_OPTIONS = createRequestTypes('GET_LANES_OPTIONS');
export const EDIT_ONBOARDING_DEATILS = createRequestTypes('EDIT_ONBOARDING_DEATILS');
export const GET_BASIC_DETAILS_OPERATOR = createRequestTypes('GET_BASIC_DETAILS_OPERATOR');
export const GET_ADDRESS_DETAILS_OPERATOR = createRequestTypes('GET_ADDRESS_DETAILS_OPERATOR');

export const VIEW_UPLOADED_DOCUMENT = createRequestTypes('VIEW_UPLOADED_DOCUMENT');
export const GET_COMPLIANCES_DETAILS_OPERATOR = createRequestTypes('GET_COMPLIANCES_DETAILS_OPERATOR');
export const GET_DOCUMENT_DETAILS_OPERATOR = createRequestTypes('GET_DOCUMENT_DETAILS_OPERATOR');
export const UPDATE_OPERATOR_BASIC_DETAILS = createRequestTypes('UPDATE_OPERATOR_BASIC_DETAILS');
export const UPDATE_OPERATOR_ADDRESS_DETAILS = createRequestTypes('UPDATE_OPERATOR_ADDRESS_DETAILS');
export const UPDATE_OPERATOR_COMPLAINCES_DETAILS = createRequestTypes('UPDATE_OPERATOR_COMPLAINCES_DETAILS');
export const UPDATE_OPERATOR_VEHICLES_DETAILS = createRequestTypes('UPDATE_OPERATOR_VEHICLES_DETAILS');
export const GET_VEHICLE_DETAILS_OPERATOR = createRequestTypes('GET_VEHICLE_DETAILS_OPERATOR');
export const GET_OPERATOR_DOCUMENT_VIEW_URL = createRequestTypes('GET_OPERATOR_DOCUMENT_VIEW_URL');
export const SEND_UNDERTAKING_LINK = createRequestTypes('SEND_UNDERTAKING_LINK');
export const SEND_TDS_LINK = createRequestTypes('SEND_TDS_LINK');
export const UPLOAD_OPERATOR_IDENTITY_DOCUMENTS = createRequestTypes('UPLOAD_OPERATOR_IDENTITY_DOCUMENTS');
export const UPDATE_OPERATOR_TDS_DETAILS = createRequestTypes('UPDATE_OPERATOR_TDS_DETAILS');
export const UPDATE_OPERATOR_DOCUMENT_DETAILS = createRequestTypes('UPDATE_OPERATOR_DOCUMENT_DETAILS');
export const GET_OPERATOR_BY_OPCODE = createRequestTypes('GET_OPERATOR_BY_OPCODE');
export const GET_ODVT_LIST = createRequestTypes('GET_ODVT_LIST');
export const POST_ODVT = createRequestTypes('POST_ODVT');
export const PATCH_ODVT = createRequestTypes('PATCH_ODVT');
export const DELETE_ODVT = createRequestTypes('DELETE_ODVT');
export const GET_VEHICLE_INFO = createRequestTypes('GET_VEHICLE_INFO');
export const GET_VEHICLE_INFO_SUCCESS = createRequestTypes('GET_VEHICLE_INFO_SUCCESS');
export const GET_VEHICLE_INFO_FAILURE = createRequestTypes('GET_VEHICLE_INFO_FAILURE');

export const GET_KYC_STATUS_REMARKS = createRequestTypes('GET_KYC_STATUS_REMARKS');
export const GET_KYC_STATUS_REMARKS_SUCCESS = createRequestTypes('GET_KYC_STATUS_REMARKS_SUCCESS');
export const GET_KYC_STATUS_REMARKS_FAILURE = createRequestTypes('GET_KYC_STATUS_REMARKS_FAILURE');

export const GET_KYC_HISTORY = createRequestTypes('GET_KYC_HISTORY');
export const GET_KYC_HISTORY_SUCCESS = createRequestTypes('GET_KYC_HISTORY_SUCCESS');
export const GET_KYC_HISTORY_FAILURE = createRequestTypes('GET_KYC_HISTORY_FAILURE');

export const getOperatorsList = {
  request: (params) => createAction(GET_OPERATORS_LIST[REQUEST], { params }),
  success: (response) => createAction(GET_OPERATORS_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_OPERATORS_LIST[FAILURE], { response }),
  resetOperatorList: () => createAction(RESET_OPERATOR_LIST),
  uncheckFlags: () => createAction(UNCHECK_FLAGS),
};

export const getOperatorById = {
  request: (id) => createAction(GET_OPERATOR_BY_ID[REQUEST], { id }),
  success: (response, id) => createAction(GET_OPERATOR_BY_ID[SUCCESS], { response, id }),
  failure: (response) => createAction(GET_OPERATOR_BY_ID[FAILURE], { response }),
};
export const getOperatorKycHistory = {
  request: (id) => createAction(GET_KYC_HISTORY[REQUEST], { id }),
  success: (response, id) => createAction(GET_KYC_HISTORY[SUCCESS], { response, id }),
  failure: (response) => createAction(GET_KYC_HISTORY[FAILURE], { response }),
};
export const getKycStatusRemarks = {
  request: (currStatus, prevStatus) => createAction(GET_KYC_STATUS_REMARKS[REQUEST], { currStatus, prevStatus }),
  success: (response, id) => createAction(GET_KYC_STATUS_REMARKS[SUCCESS], { response, id }),
  failure: (response) => createAction(GET_KYC_STATUS_REMARKS[FAILURE], { response }),
};

export const getOperatorByOpCode = {
  request: (opCode) => createAction(GET_OPERATOR_BY_OPCODE, { opCode }),
  success: (response, opCode) => createAction(GET_OPERATOR_BY_OPCODE[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_OPERATOR_BY_OPCODE[FAILURE], { response }),
};

export const getODVTList = {
  request: (opCode) => createAction(GET_ODVT_LIST[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_ODVT_LIST[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_ODVT_LIST[FAILURE], { response }),
};
export const postODVT = {
  request: (params) => createAction(POST_ODVT[REQUEST], { params }),
  success: (response, opCode) => createAction(POST_ODVT[SUCCESS], { response, opCode }),
  failure: (response) => createAction(POST_ODVT[FAILURE], { response }),
};
export const patchODVT = {
  request: (params) => createAction(PATCH_ODVT[REQUEST], { params }),
  success: (response, opCode) => createAction(PATCH_ODVT[SUCCESS], { response, opCode }),
  failure: (response) => createAction(PATCH_ODVT[FAILURE], { response }),
};
export const deleteODVT = {
  request: (params) => createAction(DELETE_ODVT[REQUEST], { params }),
  success: (response, opCode) => createAction(DELETE_ODVT[SUCCESS], { response, opCode }),
  failure: (response) => createAction(DELETE_ODVT[FAILURE], { response }),
};
export const getVehicleInformation = {
  request: (params) => createAction(GET_VEHICLE_INFO[REQUEST], { params }),
  success: (params) => createAction(GET_VEHICLE_INFO[SUCCESS], { params }),
  failure: (params) => createAction(GET_VEHICLE_INFO[FAILURE], { params }),
};
export const getBasicDetailsOperator = {
  request: (opCode) => createAction(GET_BASIC_DETAILS_OPERATOR[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_BASIC_DETAILS_OPERATOR[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_BASIC_DETAILS_OPERATOR[FAILURE], { response }),
};

export const getAddressDetailsOperator = {
  request: (opCode) => createAction(GET_ADDRESS_DETAILS_OPERATOR[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_ADDRESS_DETAILS_OPERATOR[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_ADDRESS_DETAILS_OPERATOR[FAILURE], { response }),
};

export const getCompliancesDetailsOperator = {
  request: (opCode) => createAction(GET_COMPLIANCES_DETAILS_OPERATOR[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_COMPLIANCES_DETAILS_OPERATOR[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_COMPLIANCES_DETAILS_OPERATOR[FAILURE], { response }),
};

export const viewUploadedDocument = {
  request: (params) => createAction(VIEW_UPLOADED_DOCUMENT[REQUEST], { params }),
  success: (response, params) => createAction(VIEW_UPLOADED_DOCUMENT[SUCCESS], { response, params }),
  failure: (response) => createAction(VIEW_UPLOADED_DOCUMENT[FAILURE], { response }),
};

export const getDocumentDetailsOperator = {
  request: (opCode) => createAction(GET_DOCUMENT_DETAILS_OPERATOR[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_DOCUMENT_DETAILS_OPERATOR[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_DOCUMENT_DETAILS_OPERATOR[FAILURE], { response }),
};

export const updateOperatorBasicDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_BASIC_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_BASIC_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_BASIC_DETAILS[FAILURE], { response }),
  // resetFileUrl: () => createAction(RESET_FILE_URL),
  // resetEditStatus: () => createAction(RESET_EDIT_STATUS),
  // resetTdsFileUrl: () => createAction(RESET_TDS_FILE_URL),
};

export const updateOperatorAddressDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_ADDRESS_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_ADDRESS_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_ADDRESS_DETAILS[FAILURE], { response }),
};

export const updateOperatorComplaincesDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_COMPLAINCES_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_COMPLAINCES_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_COMPLAINCES_DETAILS[FAILURE], { response }),
};

export const updateOperatorVehiclesDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_VEHICLES_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_VEHICLES_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_VEHICLES_DETAILS[FAILURE], { response }),
};

export const updateOperatorTdsDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_TDS_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_TDS_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_TDS_DETAILS[FAILURE], { response }),
};

export const updateOperatorDocumentDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_DOCUMENT_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_DOCUMENT_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_DOCUMENT_DETAILS[FAILURE], { response }),
};

export const uploadOperatorIdentityDocument = {
  request: (payload) => createAction(UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[REQUEST], { payload }),
  success: (response, payload) => createAction(UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[SUCCESS], { response, payload }),
  failure: (response) => createAction(UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[FAILURE], { response }),
};

export const getVehicleDetailsOperator = {
  request: (opCode) => createAction(GET_VEHICLE_DETAILS_OPERATOR[REQUEST], { opCode }),
  success: (response, opCode) => createAction(GET_VEHICLE_DETAILS_OPERATOR[SUCCESS], { response, opCode }),
  failure: (response) => createAction(GET_VEHICLE_DETAILS_OPERATOR[FAILURE], { response }),
};

export const sendUnderTakingLink = {
  request: (opCode) => createAction(SEND_UNDERTAKING_LINK[REQUEST], { opCode }),
  success: (response, opCode) => createAction(SEND_UNDERTAKING_LINK[SUCCESS], { response, opCode }),
  failure: (response) => createAction(SEND_UNDERTAKING_LINK[FAILURE], { response }),
};

export const sendTdsLink = {
  request: (opCode) => createAction(SEND_TDS_LINK[REQUEST], { opCode }),
  success: (response, opCode) => createAction(SEND_TDS_LINK[SUCCESS], { response, opCode }),
  failure: (error) => createAction(SEND_TDS_LINK[FAILURE], { error }),
};

export const operatorType = {
  request: () => createAction(GET_OPERATOR_TYPE[REQUEST]),
  success: (response) => createAction(GET_OPERATOR_TYPE[SUCCESS], { response }),
  failure: (response) => createAction(GET_OPERATOR_TYPE[FAILURE], { response }),
};

export const operatorStatus = {
  request: () => createAction(GET_OPERATOR_STATUS[REQUEST]),
  success: (response) => createAction(GET_OPERATOR_STATUS[SUCCESS], { response }),
  failure: (response) => createAction(GET_OPERATOR_STATUS[FAILURE], { response }),
};

export const getPhoneNo = {
  request: (params) => createAction(GET_PHONE_NO[REQUEST],{params}),
  success: (response) => createAction(GET_PHONE_NO[SUCCESS], { response }),
  failure: (response) => createAction(GET_PHONE_NO[FAILURE], { response }),
};

export const getBankAccount = {
  request: (opId) => createAction(GET_BANK_ACCOUNT[REQUEST], { opId }),
  success: (response, opId) => createAction(GET_BANK_ACCOUNT[SUCCESS], { response, opId }),
  failure: (response) => createAction(GET_BANK_ACCOUNT[FAILURE], { response }),
};

export const getOperatorSearch = {
  request: (params) => createAction(GET_OPERATOR_SEARCH[REQUEST], { params }),
  success: (response, params) => createAction(GET_OPERATOR_SEARCH[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_OPERATOR_SEARCH[FAILURE], { response }),
};

export const getVehiclesList = {
  request: (params) => createAction(GET_VEHICLES_LIST[REQUEST], { params }),
  success: (response) => createAction(GET_VEHICLES_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_VEHICLES_LIST[FAILURE], { response }),
};

export const updateBasicDetails = {
  request: (payload) => createAction(UPDATE_BASIC_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_BASIC_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_BASIC_DETAILS[FAILURE], { response }),
  resetFileUrl: () => createAction(RESET_FILE_URL),
  resetEditStatus: () => createAction(RESET_EDIT_STATUS),
  resetTdsFileUrl: () => createAction(RESET_TDS_FILE_URL),
};
export const resetTdsDecErrorMsg = {
  resetTdsDecErrorMsg: () => createAction(RESET_TDS_ERROR_MSG),
};

export const createOperatorVehicleDetails = {
  request: (payload) => createAction(CREATE_OPERATOR_VEHICLE[REQUEST], { payload }),
  success: (response) => createAction(CREATE_OPERATOR_VEHICLE[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_OPERATOR_VEHICLE[FAILURE], { response }),
};

export const updateDocuments = {
  request: (payload) => createAction(UPDATE_DOCUMENTS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_DOCUMENTS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_DOCUMENTS[FAILURE], { response }),
  resetUploadStatus: () => createAction(RESET_UPLOAD_STATUS),
};

// export const updateCompanyDetails = {
//   request: (payload) => createAction(UPDATE_COMPANY_DETAILS[REQUEST], { payload }),
//   success: (response) => createAction(UPDATE_COMPANY_DETAILS[SUCCESS], { response }),
//   failure: (response) => createAction(UPDATE_COMPANY_DETAILS[FAILURE], { response }),
// };

export const createOperator = {
  request: (payload) => createAction(CREATE_OPERATOR[REQUEST], { payload }),
  success: (response) => createAction(CREATE_OPERATOR[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_OPERATOR[FAILURE], { response }),
};

export const getTrips = {
  request: (params) => createAction(GET_TRIPS[REQUEST], { params }),
  success: (response, params) => createAction(GET_TRIPS[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_TRIPS[FAILURE], { response }),
  resetUnsettled: () => createAction(RESET_UNSETTLED),
  resetSettled: () => createAction(RESET_SETTLED),
};

export const settleTrip = {
  request: (payload) => createAction(SETTLE_TRIP[REQUEST], { payload }),
  success: (response) => createAction(SETTLE_TRIP[SUCCESS], { response }),
  failure: (response) => createAction(SETTLE_TRIP[FAILURE], { response }),
  resetSettledStatus: () => createAction(RESET_SETTLED_STATUS),
};

export const createBankAccount = {
  request: (payload) => createAction(CREATE_BANK_ACCOUNT[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(CREATE_BANK_ACCOUNT[SUCCESS], { response, requestPayload }),
  failure: (response) => createAction(CREATE_BANK_ACCOUNT[FAILURE], { response }),
};

export const editBankAccount = {
  request: (payload) => createAction(EDIT_BANK_ACCOUNT[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(EDIT_BANK_ACCOUNT[SUCCESS], { response, requestPayload }),
  failure: (response) => createAction(EDIT_BANK_ACCOUNT[FAILURE], { response }),
};

export const verifyBankAccountOtp = {
  request: (payload) => createAction(VERIFY_BANK_ACCOUNT_OTP[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(VERIFY_BANK_ACCOUNT_OTP[SUCCESS], { response, requestPayload }),
  failure: (response, requestPayload) => createAction(VERIFY_BANK_ACCOUNT_OTP[FAILURE], { response, requestPayload }),
};

export const resendBankAccountOtp = {
  request: (payload) => createAction(RESEND_BANK_ACCOUNT_OTP[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(RESEND_BANK_ACCOUNT_OTP[SUCCESS], { response, requestPayload }),
  failure: (response, requestPayload) => createAction(RESEND_BANK_ACCOUNT_OTP[FAILURE], { response, requestPayload }),
};

export const disableAccount = {
  request: (payload) => createAction(DISABLE_ACCOUNT[REQUEST], { payload }),
  success: (response) => createAction(DISABLE_ACCOUNT[SUCCESS], { response }),
  failure: (response) => createAction(DISABLE_ACCOUNT[FAILURE], { response }),
};

export const sendToThirdParty = {
  request: (payload) => createAction(SEND_TO_THIRD_PARTY[REQUEST], { payload }),
  success: (response) => createAction(SEND_TO_THIRD_PARTY[SUCCESS], { response }),
  failure: (response) => createAction(SEND_TO_THIRD_PARTY[FAILURE], { response }),
};

export const downloadLedger = {
  request: (params) => createAction(DOWNLOAD_LEDGER[REQUEST], { params }),
  success: (response) => createAction(DOWNLOAD_LEDGER[SUCCESS], { response }),
  failure: (response) => createAction(DOWNLOAD_LEDGER[FAILURE], { response }),
};

export const getFileUpload = {
  request: (payload) => createAction(GET_FILE_UPLOAD[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_FILE_UPLOAD[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_FILE_UPLOAD[FAILURE], { response }),
};

export const getTdsFileUpload = {
  request: (payload) => createAction(GET_TDS_FILE_UPLOAD[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_TDS_FILE_UPLOAD[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_TDS_FILE_UPLOAD[FAILURE], { response }),
};

export const getFileView = {
  request: (params) => createAction(GET_FILE_VIEW[REQUEST], { params }),
  success: (response, params) => createAction(GET_FILE_VIEW[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_FILE_VIEW[FAILURE], { response }),
};

// export const addTdsDeclaration = {
//   request: (payload) => createAction(ADD_TDS_DEC[REQUEST], { payload }),
//   success: (response, payload) => createAction(ADD_TDS_DEC[SUCCESS], { response, payload }),
//   failure: (response) => createAction(ADD_TDS_DEC[FAILURE], { response }),
// };

// export const editTdsDeclaration = {
//   request: (payload) => createAction(EDIT_TDS_DEC[REQUEST], { payload }),
//   success: (response, payload) => createAction(EDIT_TDS_DEC[SUCCESS], { response, payload }),
//   failure: (response) => createAction(EDIT_TDS_DEC[FAILURE], { response }),
// };

export const viewTdsFile = {
  request: (payload) => createAction(GET_TDS_VIEW_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_TDS_VIEW_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_TDS_VIEW_URL[FAILURE], { response }),
};

export const getRcLink = {
  request: (payload) => createAction(GET_RC_LINK[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_RC_LINK[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_RC_LINK[FAILURE], { response }),
  // clearRcNames: () => createAction(CLEAR_RC_NAMES),
};

export const saveRcLink = {
  request: (payload) => createAction(SAVE_RC_LINK[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_RC_LINK[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_RC_LINK[FAILURE], { response }),
};

export const setActiveVehicle = (payload) => ({
  type: SET_ACTIVE_VEHICLE,
  payload,
});

export const viewRc = (payload) => ({
  type: VIEW_RC,
  payload,
});

export const resetVehicles = () => ({
  type: RESET_VEHICLES,
});

export const resetRcView = () => ({
  type: RESET_RC_VIEW,
});

export const getLanesOptions = {
  request: () => createAction(GET_LANES_OPTIONS[REQUEST]),
  success: (response) => createAction(GET_LANES_OPTIONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_LANES_OPTIONS[FAILURE], { response }),
};

export const editOnboardingDetails = {
  request: (payload) => createAction(EDIT_ONBOARDING_DEATILS[REQUEST], { payload }),
  success: (response, payload) => createAction(EDIT_ONBOARDING_DEATILS[SUCCESS], { response, payload }),
  failure: (response) => createAction(EDIT_ONBOARDING_DEATILS[FAILURE], { response }),
};

export const resetActiveVehicle = () => ({
  type: RESET_ACTIVE_VEHICLE,
});
